import React, { useCallback } from "react";
import classNames from "classnames";
import aa from "search-insights";
import { Link } from "./link";
import useWhereToBuy from "../hooks/use-where-to-buy";
import useReevooTrack from "../hooks/use-reevoo-track";
import useStoreLocator from "../hooks/use-store-locator";
import BannerNotification from "./banner-notification";
import ButtonWTB from "./elements/button-wtb";
import { hasEcommerce } from "../utility/ecommerce";
import WhereToBuyIcon from "../icons/dove-acquistare.svg";
import CartIcon from "../icons/carrello.svg";
import PdpProducPrice from "./pdp-product-price";
import useNoRtl from "../hooks/use-no-rtl";
import PaymentMethods from "./payment-methods";

aa("init", {
  appId: "KAJKCKIXF9",
  apiKey: "a17845db9a2d70a06a8f09e8036e81c7",
});

const ALGOLIA_INDEX_NAME = process.env.GATSBY_ALGOLIA_INDEX_NAME;
const externalPDPShopify = process.env.GATSBY_SHOPIFY_EXTERNAL_PDP || false;

const PdpActions = ({
  priceData,
  labelManagerLabels,
  contributoRaee,
  bannerNotification,
  config,
  data,
  location,
  addProduct,
  adding,
  loadingCart,
  storeLink,
  pagePath,
}) => {
  const { key_prod: productId, assetId, preorderActive, shopifyServices } = data;
  const enabledForLine = [undefined, "[]"].includes(
    data.pageLine?.lineConfigurationFieldSet?.isNotEcommerce?.[0]
  );
  const ecommerceActive = hasEcommerce && enabledForLine;

  const addToCart = useCallback(() => {
    const urlSearchparams = new URLSearchParams(location.search);
    if (urlSearchparams.get("queryID") && urlSearchparams.get("objectID")) {
      aa("convertedObjectIDsAfterSearch", {
        index: ALGOLIA_INDEX_NAME,
        eventName: "Product added to cart",
        userToken: "user",
        queryID: urlSearchparams.get("queryID"),
        position: urlSearchparams.get("index"),
        objectIDs: [urlSearchparams.get("objectID")],
      });
    }
    addProduct(data, priceData, location, "PDP");
  }, [addProduct, data, priceData, location]);

  const reevooTrack = useReevooTrack(productId);
  const whereToBuyAssetId = useWhereToBuy(assetId);
  const storeLocatorPage = useStoreLocator();

  const noRtl = useNoRtl("pdp");

  const shopLink = priceData?.shopLink || data?.shopLink;

  return (
    <div className="product-detail__actions-wrapper">
      {(ecommerceActive || (priceData && enabledForLine)) && !noRtl && (
        <PdpProducPrice priceData={priceData} contributoRaee={contributoRaee} />
      )}
      <div
        className={classNames({
          "product-detail__hide": priceData === undefined && ecommerceActive,
          //"product-detail__spaced": !ecommerceActive && (!whereToBuyAssetId || !storeLocatorPage),
        })}
      >
        {priceData?.sellingPrice?.value && ecommerceActive ? (
          <PaymentMethods sellingPrice={priceData?.sellingPrice?.value} pagePath={pagePath} />
        ) : null}
        <div className="product-detail__actions-content d-flex d-md-block justify-content-center">
          {(priceData && enabledForLine) || shopLink ? (
            <div className="product-detail__addcart-wrapper">
              {ecommerceActive &&
              priceData?.sellingPrice?.value &&
              !noRtl &&
              !externalPDPShopify &&
              shopifyServices ? (
                <a
                  href={shopifyServices}
                  target="_self"
                  rel="noreferrer"
                  className="product-detail__addcart"
                >
                  <CartIcon className="icon-svg-detail" />
                  {preorderActive === "true"
                    ? labelManagerLabels.preorder
                    : labelManagerLabels.addToCart}
                </a>
              ) : ecommerceActive &&
                priceData?.sellingPrice?.value &&
                !noRtl &&
                !externalPDPShopify ? (
                <button
                  className="product-detail__addcart"
                  onClick={addToCart}
                  disabled={adding || loadingCart}
                >
                  <CartIcon className="icon-svg-detail" />
                  {preorderActive === "true"
                    ? labelManagerLabels.preorder
                    : labelManagerLabels.addToCart}
                </button>
              ) : (
                ((shopLink && !noRtl) || (shopLink && !noRtl && externalPDPShopify)) && (
                  <a
                    href={shopLink}
                    target="_blank"
                    rel="noreferrer"
                    className="product-detail__addcart"
                  >
                    <CartIcon className="icon-svg-detail" />
                    {labelManagerLabels.buyOnHaierShop}
                  </a>
                )
              )}
              {!!bannerNotification && !!bannerNotification.length && (
                <div className="d-md-none">
                  <BannerNotification data={bannerNotification[0]}></BannerNotification>
                </div>
              )}
              {!noRtl && (
                <div
                  className={classNames("product-detail__shipping-costs text-center")}
                  dangerouslySetInnerHTML={{ __html: labelManagerLabels.shippingCosts }}
                ></div>
              )}
            </div>
          ) : !ecommerceActive && whereToBuyAssetId ? (
            <>
              <ButtonWTB
                className={classNames("product-detail__addcart cswidget", noRtl && "d-none")}
                label={labelManagerLabels.whereToBuy}
                reevooTrack={reevooTrack}
                sku={data.key_prod}
                assetId={whereToBuyAssetId}
                location={location}
                storeLink={storeLink}
              />
              {!!bannerNotification && !!bannerNotification.length && (
                <div className="d-md-none">
                  <BannerNotification data={bannerNotification[0]}></BannerNotification>
                </div>
              )}
            </>
          ) : !ecommerceActive && storeLocatorPage ? (
            <>
              <Link
                to={!!storeLink ? storeLink : storeLocatorPage}
                target={!!storeLink ? "_blank" : "_self"}
                className={classNames("product-detail__addcart", noRtl && "d-none")}
                rel="noreferrer"
              >
                {labelManagerLabels.buyNow}
              </Link>
              {!!bannerNotification && !!bannerNotification.length && (
                <div className="d-md-none">
                  <BannerNotification data={bannerNotification[0]}></BannerNotification>
                </div>
              )}
            </>
          ) : (
            !!bannerNotification &&
            !!bannerNotification.length && (
              <div className="d-md-none">
                <BannerNotification data={bannerNotification[0]}></BannerNotification>
              </div>
            )
          )}
        </div>
        <div
          className={classNames(
            "product-detail__actions d-flex flex-column flex-md-row align-items-center justify-content-center",
            {
              "product-detail__actions--noprice": priceData === null && !shopLink,
              "pt-3": noRtl,
            }
          )}
        >
          {ecommerceActive &&
            (!priceData?.sellingPrice ||
              (config.wtbAndRetailersActive && !!config.wtbAndRetailersActive?.length)) &&
            // !shopLink &&
            (whereToBuyAssetId ? (
              <>
                <ButtonWTB
                  className={classNames(
                    "product-detail__btn-wtb align-self-md-stretch cswidget",
                    noRtl && "d-none"
                  )}
                  priceData={priceData}
                  label={labelManagerLabels.whereToBuy}
                  reevooTrack={reevooTrack}
                  sku={data.key_prod}
                  assetId={whereToBuyAssetId}
                  location={location}
                  storeLink={storeLink}
                />
                {!!bannerNotification && !!bannerNotification.length && (
                  <div className="d-md-none">
                    <BannerNotification data={bannerNotification[0]}></BannerNotification>
                  </div>
                )}
              </>
            ) : (
              <>
                {storeLocatorPage && !noRtl && (
                  <Link
                    to={!!storeLink ? storeLink : storeLocatorPage}
                    target={!!storeLink ? "_blank" : "_self"}
                    className="product-detail__btn-wtb align-self-md-stretch product-detail__btn-wtb--nodecoration"
                    rel="noreferrer"
                  >
                    {priceData && <WhereToBuyIcon className="icon-svg" />}
                    <span>{labelManagerLabels.whereToBuy}</span>
                  </Link>
                )}
                {!!bannerNotification && !!bannerNotification.length && (
                  <div className="d-md-none">
                    <BannerNotification data={bannerNotification[0]}></BannerNotification>
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PdpActions;
